"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
const useIsTouchScreenDevice = () => {
    const [isTouchScreenDevice, setIsTouchScreenDevice] = (0, react_1.useState)(false);
    const handleIsTouchScreenDevice = () => {
        if (typeof window !== 'undefined') {
            const nav = window.navigator || navigator;
            const isTouchScreen = (('ontouchstart' in window) ||
                (nav.maxTouchPoints > 0) ||
                (nav.msMaxTouchPoints > 0));
            setIsTouchScreenDevice(isTouchScreen);
        }
        else {
            setIsTouchScreenDevice(false);
        }
    };
    (0, react_1.useEffect)(() => {
        handleIsTouchScreenDevice();
        window.addEventListener('resize', handleIsTouchScreenDevice);
        return () => {
            window.removeEventListener('resize', handleIsTouchScreenDevice);
        };
    }, []);
    return isTouchScreenDevice;
};
exports.default = useIsTouchScreenDevice;
//# sourceMappingURL=useIsTouchScreenDevice.js.map